import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";

export default function CtaBand({
  title,
  subtitle,
  primaryHref = "/contact?get-quote=1",
  primaryLabel,
  secondaryHref = "/webshop",
  secondaryLabel,
}) {
  const { t } = useI18n();
  const finalTitle = title || t("cta.ready_title");
  const finalSubtitle = subtitle || t("cta.ready_sub");
  const finalPrimary = primaryLabel || t("cta.get_quote");
  const finalSecondary = secondaryLabel || t("cta.shop_boxes");

  return (
    <section
      className="relative py-20 overflow-hidden"
      data-testid="cta-band"
    >
      <div className="container-x">
        <div className="relative rounded-3xl bg-brand-gradient text-white p-10 lg:p-14 shadow-brand-deep overflow-hidden">
          <div className="absolute inset-0 grid-pattern-light opacity-50 pointer-events-none" aria-hidden="true" />
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-brand-500/30 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -left-12 w-72 h-72 rounded-full bg-brand-300/20 blur-3xl pointer-events-none" />
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7">
              <h2 className="font-chivo font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
                {finalTitle}
              </h2>
              <p className="text-white/80 mt-4 text-lg max-w-2xl leading-relaxed">{finalSubtitle}</p>
            </div>
            <div className="md:col-span-5 flex flex-col sm:flex-row gap-3 md:justify-end">
              <Link
                to={primaryHref}
                data-testid="cta-band-primary"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-xl bg-white text-brand-900 hover:bg-brand-50 font-chivo font-bold text-[14px] tracking-wide uppercase shadow-brand-card transition-all active:scale-[0.98]"
              >
                {finalPrimary} <ArrowRight className="w-4 h-4" strokeWidth={2.25} />
              </Link>
              <Link
                to={secondaryHref}
                data-testid="cta-band-secondary"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-xl bg-white/0 border border-white/30 text-white hover:bg-white/10 hover:border-white/60 font-chivo font-bold text-[14px] tracking-wide uppercase transition-all"
              >
                {finalSecondary}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
